import { render } from "./ModalFooter.vue?vue&type=template&id=0c8f7336"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"
script.render = render

export default script